import { NgModule } from '@angular/core';
import { BidiModule, Directionality } from '@angular/cdk/bidi';
import { ElDirectionality } from './bidi-service';

@NgModule({
  providers: [
    { provide: ElDirectionality, useExisting: Directionality },
  ],
})
export class ElBidiModule extends BidiModule {}
